module.exports = __webpack_public_path__ + "img/present_white.63d09e19.svg";